import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { MetadataVM } from './MetadataVM';
import './metadata.scss';
import { CollapseMenu } from '../../common/CollapseMenu/CollapseMenu';

const MetadataFormComponent = (props: any) => {
  const vm = useRef(new MetadataVM()).current;

  React.useEffect(() => {
    vm.getMetadata();
  }, []);

  let rowIdx = 0;

  return (
    <>
      {vm.metadata.map((item) => {
        return (
          <div>
            <CollapseMenu
              titleClass={'metadata-menu'}
              noIcon={true}
              title={item.dataType + ' Metadata'}
              isOpen={props.isOpen !== undefined ? props.isOpen : true}
            >
              <div className="container">
                <div className="row">
                  <table>
                    <thead>
                      <th>Data Type - {item.dataType}</th>
                    </thead>
                    <tbody>
                      {Object.keys(item).map((key) => {
                        if (vm.metadataLabelsCol1.includes(key)) {
                          rowIdx++;
                          let entries = item[key] === null ? 'N/A' : item[key];
                          if (item[key] !== null && key.includes('Date')) {
                            entries = vm.validateDate(item[key]);
                          }
                          return (
                            <tr>
                              <td className={rowIdx % 2 ? 'td-grey' : 'td-white'}>
                                {vm.makeLabelPretty(key) + ': '}
                                <div
                                  className="ml-1"
                                  style={props.isOpen !== undefined ? { width: 'auto' } : { width: '100%' }}
                                >
                                  {entries}
                                </div>
                              </td>
                            </tr>
                          );
                        }
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="row metadata-bottom-row">
                  <table>
                    <tbody>
                      {Object.keys(item).map((key) => {
                        if (vm.metadataLabelsCol2.includes(key)) {
                          let entries = item[key] === null ? 'N/A' : item[key];
                          if (item[key] !== null && key.includes('Date')) {
                            entries = vm.validateDate(item[key]);
                          }
                          return (
                            <tr>
                              <td>
                                <strong>{vm.makeLabelPretty(key) + ':   '}</strong>
                                <div style={props.isOpen !== undefined ? { width: 'auto' } : { width: '100%' }}>
                                  {entries}
                                </div>
                              </td>
                            </tr>
                          );
                        }
                      })}
                      <tr>
                        <td>&nbsp;</td>
                      </tr>
                      <tr>
                        <a
                          className="usa-button usa-button--outline"
                          href={vm.validURL(item['dataSource'])}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Data Source
                        </a>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </CollapseMenu>
            <hr />
          </div>
        );
      })}
    </>
  );
};

export const Metadata = observer(MetadataFormComponent);
